export default __webpack_public_path__ + "img/1-1-8f4b56a5.png";